import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { ObservableInput } from 'rxjs';
import { catchError } from 'rxjs/operators';

class Options {
    headers: HttpHeaders;

    params?: HttpParams | {
        [param: string]: string | string[];
    };

    constructor(params?: {[param: string]: string | string[]}) {
        this.headers = new HttpHeaders({
            Authorization: 'Token ',
            'Accept-Language': 'RU'
        });

        this.params = params;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProviderApi {
    constructor(private http: HttpClient) {}

    async get(url: string, params: {[param: string]: string | string[]}, checkToken: () => Promise<void>, errorHandler: (error: HttpErrorResponse) => ObservableInput<any>): Promise<any> {
        await checkToken();

        return this.http.get(url, new Options(params))
            .pipe(catchError(errorHandler))
            .toPromise()
    }

    async post(url: string, body: any, checkToken: () => Promise<void>, errorHandler: (error: HttpErrorResponse) => ObservableInput<any>): Promise<any> {
        await checkToken();

        return this.http.post(url, body, new Options())
            .pipe(catchError(errorHandler))
            .toPromise();
    }

    async delete(url: string, checkToken: () => Promise<void>, errorHandler: (error: HttpErrorResponse) => ObservableInput<any>): Promise<any> {
        await checkToken();

        return this.http.delete(url, new Options())
            .pipe(catchError(errorHandler))
            .toPromise();
    }

    async patch(url: string, body: any, checkToken: () => Promise<void>, errorHandler: (error: HttpErrorResponse) => ObservableInput<any>): Promise<any> {
        await checkToken();

        return this.http.patch(url, body, new Options())
            .pipe(catchError(errorHandler))
            .toPromise();
    }
}
